/* eslint-disable eqeqeq */
import { Platform } from 'react-native';

export type envType = 'dev' | 'test' | 'prod';
interface configface {
  wapDomain: string; //wap域名
  pzptLink: string; //新的配置平台
  dsbcLink: string; //业务中心
  pointLink: string; //积分中心接口
  pointAppkey: string; //积分中心appkey
  redPacketUrl: string; //现金红包链接
  zqhpLink: string /* 成都后台 */;
  invId: string; //活动id
  identityUrl: string /*实名认证地址*/;
  identityStudentUrl: string /*學生認證*/;
  /*校园合伙人申请*/
  campusUrl: string;
  /**
   * 人脸识别认证（活体认证）
   * */
  faceUrl: string;
}
// TODO
let _env: string = 'prod';
// let _env: string = 'test';
// let _env: string = 'pre';
let env_: envType = _env as envType;

if (Platform.OS === 'web') {
  const host = window.location.host;
  if (host.indexOf('172.27') != -1 || host.indexOf('localhost') != -1 || host.indexOf('test.eastmoney.com') != -1) {
    env_ = 'dev';
  } else if (host.indexOf('contestcs.eastmoney.com') != -1 || host.indexOf('ceshi.securities.eastmoney.com') != -1) {
    env_ = 'test';
  } else {
    env_ = 'prod';
  }
}

let _config = {
  dev: {
    wapDomain: 'http://contestcs.eastmoney.com/jrtzs/wap',
    pzptLink: 'https://ceshi.securities.eastmoney.com:7438/contestapi',
    dsbcLink: 'http://10.10.184.216:8701',
    pointLink: 'https://pointcpftest.eastmoney.com:9001/TaskServiceV2/',
    pointAppkey: 'ZwkfaXXXfI',
    redPacketUrl: 'https://pointcpftest.eastmoney.com/CashWithdrawal/',
    zqhpLink: 'https://ceshi.securities.eastmoney.com:7438/zqhdapi',
    invId: '4',
    identityUrl: 'https://maccountuat2.eastmoney.com/mobile/newSite/authentication/',
    identityStudentUrl: 'https://marketingcs.dfcfs.com/views/campusverify/index',
    campusUrl: 'https://marketing.dfcfs.com/xyhd/campuspartner/index?fromAct=dsflg',
    faceUrl:
      'https://maccountuat2.eastmoney.com/mobile/newSite/livedetection?sourceToken=zqhd.welfareOfficer&action=%E5%A5%96%E5%93%81%E9%A2%86%E5%8F%96',
  },
  test: {
    wapDomain: 'http://contestcs.eastmoney.com/jrtzs/wap',
    pzptLink: 'https://ceshi.securities.eastmoney.com:7438/contestapi',
    dsbcLink: 'http://61.129.116.181:8701',
    pointLink: 'https://pointcpftest.eastmoney.com:9001/TaskServiceV2/',
    pointAppkey: 'ZwkfaXXXfI',
    redPacketUrl: 'https://pointcpftest.eastmoney.com/CashWithdrawal/',
    zqhpLink: 'https://ceshi.securities.eastmoney.com:7438/zqhdapi',
    invId: '4',
    identityUrl: 'https://maccountuat2.eastmoney.com/mobile/newSite/authentication/',
    identityStudentUrl: 'https://marketingcs.dfcfs.com/views/campusverify/index',
    campusUrl: 'https://marketing.dfcfs.com/xyhd/campuspartner/index?fromAct=dsflg',
    faceUrl:
      'https://maccountuat2.eastmoney.com/mobile/newSite/livedetection?sourceToken=zqhd.welfareOfficer&action=%E5%A5%96%E5%93%81%E9%A2%86%E5%8F%96',
  },
  pre: {
    wapDomain: 'https://young.eastmoney.com/jrtzs/wap',
    pzptLink: 'https://emcontestapi.eastmoney.com',
    dsbcLink: 'https://competition.eastmoney.com:8701',
    pointLink: 'https://empointcpf.eastmoney.com:9001/TaskServiceV2/',
    pointAppkey: 'EIBnBlYuvK',
    redPacketUrl: 'https://empointcpf.eastmoney.com/cashredpackets/CashWithdrawal/',
    zqhpLink: 'https://zqhduat.dfcfs.cn/zqhdapi',
    invId: '4',
    identityUrl: 'https://maccount2.eastmoney.com/mobile/newSite/authentication/',
    identityStudentUrl: 'https://marketing.dfcfs.com/views/campusverify/index',
    campusUrl: 'https://marketing.dfcfs.com/xyhd/campuspartner/index?fromAct=dsflg',
    faceUrl:
      'https://maccount2.eastmoney.com/mobile/newSite/livedetection?sourceToken=zqhd.inviteNew&action=%E5%A5%96%E5%93%81%E9%A2%86%E5%8F%96',
  },
  prod: {
    wapDomain: 'https://young.eastmoney.com/jrtzs/wap',
    pzptLink: 'https://emcontestapi.eastmoney.com',
    dsbcLink: 'https://competition.eastmoney.com:8701',
    pointLink: 'https://empointcpf.eastmoney.com:9001/TaskServiceV2/',
    pointAppkey: 'EIBnBlYuvK',
    redPacketUrl: 'https://empointcpf.eastmoney.com/cashredpackets/CashWithdrawal/',
    zqhpLink: 'https://zqhd.dfcfs.cn/zqhdapi',
    invId: '4',
    identityUrl: 'https://maccount2.eastmoney.com/mobile/newSite/authentication/',
    identityStudentUrl: 'https://marketing.dfcfs.com/views/campusverify/index',
    campusUrl: 'https://marketing.dfcfs.com/xyhd/campuspartner/index?fromAct=dsflg',
    faceUrl:
      'https://maccount2.eastmoney.com/mobile/newSite/livedetection?sourceToken=zqhd.inviteNew&action=%E5%A5%96%E5%93%81%E9%A2%86%E5%8F%96',
  },
};

let config: configface = _config[env_];

export function useConfig(env: envType) {
  if (env) {
    env_ = env;
  }

  // config = _config[env_];
  //本地开发环境测试
  // config = _config['test'];
}

export default config;
